<template>
  <div id="popup-wrap">
    <van-popup v-model="isDetail" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">影票详情</div>
        </div>
        <div class="popup-content">
          <div class="item-box">
            <div class="item-name">影片</div>
            <div class="item-value"><img :src="info.movie_pic"/></div>
          </div>
          <div class="item-box">
            <div class="item-name">名称</div>
            <div class="item-value">{{ info.movie_title }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">时间</div>
            <div class="item-value">{{ info.movie_time }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">影院</div>
            <div class="item-value">{{ info.cinema }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">座位</div>
            <div class="item-value"><span class="color-222 seat-text" v-for="(item,index) of info.seatArr" :key="index">{{item}}</span></div>
          </div>
          <div class="item-box">
            <div class="item-name">放映时间</div>
            <div class="item-value">{{ info.start_time }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">厅/语言</div>
            <div class="item-value">{{ info.hall }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">城市</div>
            <div class="item-value">{{ info.city }}</div>
          </div>
          <div class="item-box">
            <div class="item-name">地址</div>
            <div class="item-value">{{ info.address }}</div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="sure-btn" @click="handelSure">确定</div>
        </div>
      </div>
    </van-popup>
    <img v-show="isDetail" class="close-img-btn" src="../../../../../assets/img/h5/official/pop_btn_cancel.png" @click="handelCancel"/>
  </div>
</template>

<script>
  import { Modal } from 'view-design'
  export default {
    name: "Detail",
    components: { Modal },
    props: {},
    created() {},
    data: function () {
      return {
        isDetail: false,
        loading:false,
        // info:{
        //   movie_pic:'https://gw.alicdn.com/i3/O1CN01rZi5il1tJ5VNjCDah_!!6000000005880-0-alipicbeacon.jpg_480x480Q30s150.jpg',
        //   movie_title:'拆弹专家2',
        //   movie_time:'明天 12月6日 18:08',
        //   cinema: '万达影院',
        //   seat:'5排7座',
        //   start_time:'2020-12-27 12:34:00',
        //   hall:'3号激光厅（国语3D）',
        //   city:'厦门',
        //   address:'厦门市集美区银江路137号同集南路万达广场5号门娱乐区4楼'
        // }
        info:{
          movie_pic:'',
          movie_title:'',
          movie_time:'',
          cinema: '',
          seat:'',
          start_time:'',
          hall:'',
          city:'',
          address:'',
          seatArr:[]
        }
      }
    },
    methods: {
      init: function (row) {
        this.isDetail = true
        let movieInfo = row.movieInfo;
        movieInfo = JSON.parse(movieInfo)
        let seat = row.seat;
        this.info = {
          movie_pic: movieInfo[6],
          movie_title: movieInfo[5],
          movie_time: row.createTime,
          cinema: movieInfo[0],
          seat:seat,
          start_time:movieInfo[3],
          hall: movieInfo[1],
          city: movieInfo[8],
          address: movieInfo[7],
          seatArr: JSON.parse(seat)? JSON.parse(seat):seat
        }
      },
      handelCancel: function () {
        this.isDetail = false
      },
      handelSure: function () {
        this.handelCancel();
      },
    }
  }
</script>

<style lang="less" scoped>
.popup-content{
  padding:0 20px 15px;
  .item-box{
    display: flex;
    font-size: 13px;
    margin-bottom: 8px;
    .item-name{
      text-align: right;
      color: #666666;
      width: 52px;
    }
    .item-value{
      padding-left: 15px;
      color: #222222;
      word-break: break-all;
      max-width: 208px;
      img{
        width: 44px;
      }
    }
  }
  .item-box:last-child{
    margin-bottom: 0;
  }
}

.close-img-btn{
  color: #FFFFFF;
  z-index: 10000;
  position: absolute;
  width: 30px;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/order/modal/TicketDetail.vue